import { useQuery } from "@tanstack/react-query";

import { getProjectsProjectIDActorVoices } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { PROJECTS_QUERY_KEYS } from "./queryKeys";

export function useProjectActorVoicesQuery(projectId: string) {
  return useQuery({
    queryKey: PROJECTS_QUERY_KEYS.actorVoices(projectId),
    queryFn: processResponse(() => getProjectsProjectIDActorVoices(projectId)),
    enabled: !!projectId,
  });
}
